import { useLocationGroupStore } from '@frontend/scope';
import { createShallowStore, createStore } from '@frontend/store';

interface ScheduleLocationTimezoneStore {
  locationTimezoneMap: Record<string, string>;
  setLocationTimezoneMap: (locationTimezoneMap: Record<string, string>) => void;
}

const useScheduleLocationTimezoneStore = createStore<ScheduleLocationTimezoneStore>(
  (set) => ({
    locationTimezoneMap: {},
    setLocationTimezoneMap: (locationTimezoneMap) => {
      set({ locationTimezoneMap });
    },
  }),
  {
    name: 'schedule-location-timezone-store',
  }
);

export const useScheduleLocationTimezoneShallowStore = createShallowStore<ScheduleLocationTimezoneStore>(
  useScheduleLocationTimezoneStore
);

const updateLocationTimezoneMap = () => {
  const { selectedLocationIds, locationData } = useLocationGroupStore.getState();

  const locationTimezoneMap = selectedLocationIds?.reduce<Record<string, string>>((acc, locationId) => {
    const timezone = locationData?.[locationId]?.timezone ?? '';

    if (timezone && locationId) {
      acc[locationId] = timezone;
    }
    return acc;
  }, {});

  useScheduleLocationTimezoneStore.getState().setLocationTimezoneMap(locationTimezoneMap ?? {});
};

useLocationGroupStore.subscribe((state) => state.locationData, updateLocationTimezoneMap);
useLocationGroupStore.subscribe((state) => state.selectedLocationIds, updateLocationTimezoneMap);
